import React from 'react'

import Markdown from '../components/molecules/Markdown'

import { checkMention } from '.'

// Adds markdown to a string
const transformContent = (
  content,
  className,
  users,
  you,
  classNameOwn,
  isYours
) => {
  if (!content || typeof content !== 'string') {
    return content
  }

  // checks if content is a mention before applying styling
  const isMention = checkMention(content, className, users, you, classNameOwn)

  return isMention ? (
    <Markdown isYours={isYours}>{isMention}</Markdown>
  ) : (
    <Markdown isYours={isYours}>{content}</Markdown>
  )
}

export default transformContent
